<div class="header mat-dialog-left-right-padding">
  <h2>{{ data.title }}</h2>
  <mat-icon (click)="close(false)">clear</mat-icon>
</div>
<div class="mat-dialog-contents">
  {{ data.message }}
</div>
<div class="mat-dialog-action">
  <button *ngIf="data.sideButton" mat-button class="secondary" (click)="close(false)">{{ data.sideButton }}</button>
  <button mat-button class="secondary" (click)="close()">{{ data.cancelButton }}</button>
  <button
    mat-button
    [ngClass]="{ error: data.state === 'warn', primary: data.state === 'primary', accent: data.state === 'accent' }"
    (click)="close(true)"
  >
    {{ data.acceptButton }}
  </button>
</div>
